import React from "react";
import PricingTable from "./PricingTable";
import BoldCell from "./BoldCell";
import { pricingInfo } from "../../data/pricing-page-data";

type StorageTableProps = {
  currency: string;
};

const StorageTable: React.FC<StorageTableProps> = ({ currency, ...props }) => {
  return (
    <PricingTable>
      <tbody>
        <tr>
          <BoldCell>Storage</BoldCell>
          <td>{pricingInfo.diskStorage[currency]} GB/month</td>
        </tr>
        <tr>
          <BoldCell>Backups</BoldCell>
          <td>
            {pricingInfo.backups[currency]} GB/month
          </td>
        </tr>
      </tbody>
    </PricingTable>
  );
};

export default StorageTable;
